<template>
  <div class="ub ub-ac ub-pc">
    <div style="display: flex; position: relative; justify-content: center">
      <div class="btn-list" ref="tableShowBtnRef">
        <show-button
          :biz-type="bizType"
          :record="record"
          :showLostOrderBtn="showLostOrderBtn"
          :bizId="bizId"
          :bizName="bizName"
          :loading="loading"
          :examineAccess="examineAccess"
          :showVoidBtn="showVoidBtn"
          :showCancelBtn="showCancelBtn"
          :existRelation="existRelation"
          :showRejectBtn="showRejectBtn"
          :showAgreeBtn="showAgreeBtn"
          :showSubmitBtn="showSubmitBtn"
          :path="path"
          :viewPath="viewPath"
          :showEditFlg="showEditFlg"
          @refreshApprovalDetail="refreshApprovalDetail"
        />
      </div>
      <a-dropdown v-if="isShowDrop" :getPopupContainer="getContainer">
        <div class="trigger-icon">
          <svg-icon icon-class="morebtn" size="12" />
        </div>
        <template #overlay>
          <a-menu class="btn-menu">
            <show-button
              :biz-type="bizType"
              :record="record"
              :showLostOrderBtn="showLostOrderBtn"
              :bizId="bizId"
              :bizName="bizName"
              :loading="loading"
              :examineAccess="examineAccess"
              :showVoidBtn="showVoidBtn"
              :showCancelBtn="showCancelBtn"
              :existRelation="existRelation"
              :showRejectBtn="showRejectBtn"
              :showAgreeBtn="showAgreeBtn"
              :showSubmitBtn="showSubmitBtn"
              :path="path"
              :viewPath="viewPath"
              :showEditFlg="showEditFlg"
              @refreshApprovalDetail="refreshApprovalDetail"
            />
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  ref,
  PropType,
  watch,
  onUpdated,
  nextTick,
} from "vue";
import { ApprovalFlowService } from "./approval-flow.service";
import SubmitApprovalBtn from "./components/submit-approval-btn.vue";
import AgreeBtn from "./components/agree-btn.vue";
import RejectBtn from "./components/reject-btn.vue";
import CancelBtn from "./components/calcel-btn.vue";
import VoidBtn from "./components/void-btn.vue";
import { getCurrentUserId, getNoticeList } from "@/utils";
import { useStore } from "@/store";
import LostOrderBtn from "./components/lost-order-btn.vue";
import { useFlowEmitter } from "@/utils/emitter";
import request from "./cache-request";
import { ApprovalDetailResp } from "@/components/approval-table-flow-btn/approval-flow.interface";
import ShowButton from "./components/show-button.vue";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
export default defineComponent({
  isGlobal: true,
  name: "ApprovalTableFlowBtn",
  components: {
    SubmitApprovalBtn,
    AgreeBtn,
    RejectBtn,
    CancelBtn,
    VoidBtn,
    LostOrderBtn,
    ShowButton,
  },
  props: {
    bizType: {
      type: String,
      required: true,
    },
    record: {
      type: Object as PropType<any>,
    },
    path: {
      type: String,
      default: "",
    },
    viewPath: {
      type: String,
      default: "",
    },
    noVoidFlow: {
      type: Boolean,
      default: false,
    },
    createBy: {
      type: String,
    },
    eventName: {
      type: String,
    },
    examineAccess: {
      type: String,
    },
    editAccess: {
      type: String,
    },
    notVoid: {
      type: Boolean,
    },
    // 接口需要
    bizNameKey: {
      type: String,
    },
  },
  emits: ["reloadFlowStatus", "resetStatus", "refresh:tableData", "update:createBy"],
  setup(props, { emit }) {
    const { onEvent, emitEvent } = useFlowEmitter();
    const store = useStore();
    const bizId = computed(() => {
      return (props as any).record.id;
    });
    const showEditFlg = computed(() => {
      let t = store.state.user.buttons[props.editAccess || ""];
      return t && showEditBtn.value && (props as any).record.status !== "ygb";
    });
    const bizName = computed(() => {
      let name = null;
      if (props.bizNameKey) {
        name = props.bizNameKey as any;
      } else {
        name = (props as any).record.name
          ? (props as any).record.name
          : (props as any).record.projectName;
      }

      //采购付款申请
      if (!name && props.bizType == "purchase_payment_apply_examine") {
        name = (props as any).record.bizNo;
      }

      //入库单 出库单 其他入库 其他出库
      if (!name) {
        if (
          [
            "put_storage_receipts",
            "take_out_receipts",
            "other_put_storage_receipts",
            "other_take_out_receipts",
          ].includes(props.bizType)
        ) {
          name = (props as any).record.repertotyName;
        }
      }
      //分包付款申请
      if (!name && props.bizType == "subcontract_payment_apply_examine") {
        name = (props as any).record.subcontractName;
      }
      //租赁结算
      if (!name && props.bizType == "project_lease_settlement_examine") {
        name = (props as any).record.leaseSettlementName;
      }
      //租赁付款申请
      if (!name && props.bizType == "lease_payment_apply_examine") {
        name = (props as any).record.cooperationCompanyName;
      }
      //开票管理
      if (!name && props.bizType == "make_invoice_examine") {
        name = (props as any).record.id;
      }
      //收票管理
      if (!name && props.bizType == "income_invoice_examine") {
        name = (props as any).record.id;
      }
      return name;
    });
    let existRelation = ref(false);
    const state = reactive(<
      {
        flowStatus: string;
        flowType: string;
        currentUserId: string;
        auditUsers: string[];
        createBy: string;
        loading: boolean;
        invalid: number;
      }
    >{
      flowStatus: "",
      flowType: "",
      currentUserId: getCurrentUserId(),
      auditUsers: [],
      createBy: "",
      loading: false,
      invalid: 0,
    });

    //
    // 待提交        提交审批，编辑
    // 审批中    tjsp  同意，拒绝，撤销
    // 审批中    yzf    同意，拒绝，撤销
    // 审批通过  tjsp  作废
    // 审批通过  yzf    无操作按钮
    // 审批驳回  tjsp  提交审批，编辑
    // 审批驳回  yzf    作废
    // 已撤销    tjsp  编辑，提交审批
    // 已撤销    yzf    作废
    //
    // tjsp：提交审批流程
    // yzf：作废流程

    const showSubmitBtn = computed(() => {
      return (
        state.createBy == state.currentUserId &&
        (state.flowStatus === "dtj" ||
          (state.flowStatus === "ycx" && state.flowType === "tjsp") ||
          (state.flowStatus === "spbtg" && state.flowType === "tjsp"))
      );
    });
    const showLostOrderBtn = computed(() => {
      return (
        (state.flowStatus === "dtj" && !state.flowType) ||
        (state.flowStatus === "ycx" && state.flowType === "tjsp") ||
        (state.flowStatus === "spbtg" && state.flowType === "tjsp")
      );
    });
    const showAgreeBtn = computed(() => {
      return state.flowStatus === "spz" && state.auditUsers.includes(state.currentUserId);
    });

    const showRejectBtn = computed(() => {
      return state.flowStatus === "spz" && state.auditUsers.includes(state.currentUserId);
    });

    const showCancelBtn = computed(() => {
      return state.flowStatus === "spz" && state.createBy == state.currentUserId;
    });

    const showVoidBtn = computed(() => {
      //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
      //只有保证金页面才调用这个接口,只有保证金下才判断invalid,invalid=0不可作废，invalid=1可作废

      //已被对外付款单关联的采购付款申请应该不可作废
      let isTrue = state.createBy === state.currentUserId;
      if (props.bizType == "purchase_payment_apply_examine") {
        isTrue = isTrue && state.invalid == 1;
      }
      isTrue = isTrue && !props.notVoid;
      if (props.bizType == "purchase_receive_order_examine") {
        //修改YF-110359 未入库可作废，部分入库和入库完毕不可作废
        return (
          isTrue &&
          ((state.flowStatus === "spz" &&
            state.flowType === "tjsp" &&
            props.record.storageStatus === "wrk") ||
            (state.flowStatus === "sptg" &&
              state.flowType === "tjsp" &&
              props.record.storageStatus === "wrk"))
        );
      }
      return (
        isTrue &&
        ((state.flowStatus === "sptg" && state.flowType === "tjsp" && !props.noVoidFlow) ||
          (state.flowStatus === "spbtg" && state.flowType === "yzf") ||
          (state.flowStatus === "ycx" && state.flowType === "yzf"))
      );
    });
    const showEditBtn = computed(() => {
      return (
        state.createBy === state.currentUserId &&
        (state.flowStatus === "dtj" ||
          (state.flowStatus === "ycx" && state.flowType === "tjsp") ||
          (state.flowStatus === "spbtg" && state.flowType === "tjsp"))
      );
    });
    const detail = ref<ApprovalDetailResp | null>(null);

    const { data: detail2, run: runDetail2 } = ApprovalFlowService.existRelationOrNot();
    const { data: detail3, run: runDetail3 } = ApprovalFlowService.existAssuringRelationOrNot();
    const { data: detail4, run: runDetail4 } =
      ApprovalFlowService.existAssuringReturnRelationOrNot();
    // const { data: detail5, run: runDetail5 } = ApprovalFlowService.existPaymentPage(); //根据付款合同id查询对应的对外付款单
    //处理返回结果
    const dealDetail = (flg) => {
      if (detail && detail.value) {
        const { flowStatus, flowType, auditUsers, createBy, invalid } = detail.value;
        state.flowStatus = flowStatus;
        // if( props.bizType == "purchase_apply_examine"){
        //   state.flowStatus = props.record?.flowStatus;
        // }
        state.auditUsers = auditUsers;
        state.flowType = flowType;
        state.invalid = invalid;
      }
    };

    function runDetail(fn?: () => void) {
      let bizId = (props as any).record.id;
      request({ bizType: props.bizType, bizId }, (data) => {
        if (!data) return;
        for (let i = 0; i < data.length; i++) {
          if (data[i].bizId === bizId) {
            detail.value = data[i];
            dealDetail(null);
            fn && fn();
            break;
          }
        }
      });
    }
    //由于审核组件接口无法返回待提交时的创建人id，createBy是null，所以createBy字段通过监听列表createBy的变化来取值
    watch(
      () => (props.record as any).createBy,
      (n, o) => {
        state.createBy = n;
      },
      { immediate: true }
    );
    watch(
      () => props.record,
      (n, o) => {
        init();
      },
      { deep: true }
    );

    const { run: getSimpleDetail } = ApprovalFlowService.useDetailApi();
    //刷新审核组件
    const refreshApprovalDetail = async () => {
      //刷新审核组件接口
      const bizId = (props as any).record.id;
      const bizType = props.bizType;
      const res = await getSimpleDetail({ bizId, bizType });

      if (res?.respCode === "0000" && res.data) {
        detail.value = res.data;
        dealDetail(null);

        await getNoticeList(store);

        //审核状态变更了，通知列表刷新数据
        emitEvent({ eventName: props.eventName, isSelf: true });
        //处理是否需要红点提示
      }
    };
    //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
    //只有保证金页面才调用这个接口
    const existRelationOrNot = async () => {
      existRelation.value = true;
      const { bizType } = props;
      let bizId = (props as any).record.id;
      let res = await runDetail2(bizId);
      if (res.respCode === "0000" && detail2.value) {
        existRelation.value = detail2.value.count > 0;
        // console.log("existRelation.value", existRelation.value);
      } else {
        // message.error(res.respDesc);
      }
    };
    const existassuringRelationOrNot = async () => {
      const { bizType } = props;
      let bizId = (props as any).record.id;
      let res = await runDetail3(bizId);
      if (res.respCode === "0000" && detail3.value) {
        existRelation.value = detail3.value.count > 0;
        // console.log("existRelation.value", existRelation.value);
      } else {
        // message.error(res.respDesc);
      }
    };
    const existassuringReturnRelationOrNot = async () => {
      const { bizType } = props;
      let bizId = (props as any).record.id;
      let res = await runDetail4(bizId);
      if (res.respCode === "0000" && detail4.value) {
        existRelation.value = detail4.value.count > 0;
        // console.log("existRelation.value", existRelation.value);
      } else {
        // message.error(res.respDesc);
      }
    };
    //查询租赁付款申请的合同是否有对应的对外付款单相关联，如果关联不可作废
    // const existPaymentPage =async () => {
    //   existRelation.value = true
    //   const { bizType } = props;
    //   let paymentContractId = (props as any).record.paymentContractId;
    //   let res = await runDetail5(paymentContractId);
    //   if (res.respCode === "0000" && detail5.value.length) {
    //     existRelation.value = detail5.value.length > 0;
    //     // console.log("existRelation.value", existRelation.value);
    //   }else {

    //   }
    // }
    const onLoading = (value) => {
      state.loading = value;
    };
    const init = async () => {
      // await getDetail(true);
      runDetail(async () => {
        //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
        //只有保证金页面才调用这个接口  这里缺少保证金判断接口

        //已被对外付款单关联的采购付款申请、分包付款申请、租赁付款申请应该不可作废
        if (
          [
            "purchase_payment_apply_examine",
            "subcontract_payment_apply_examine",
            "lease_payment_apply_examine",
          ].includes(props.bizType)
        ) {
          await existRelationOrNot();
        }
        if (props.bizType === "assuring_money_examine") {
          await existassuringRelationOrNot();
        }
        if (props.bizType === "margin_payment_examine") {
          await existassuringReturnRelationOrNot();
        }
        // if(props.bizType ==="lease_payment_apply_examine"){//查询租赁付款申请的合同是否有对应的对外付款单相关联，如果关联不可作废
        //   await existPaymentPage()
        // }
      });
    };
    onMountedOrActivated(async () => {
      init();
      onEvent(async (o) => {
        //只触发组件名称一直的事件，且不是列表审核组件自身发起的
        if (o.eventName === props.eventName && !o.isSelf) {
          // await refresh();
          // dealDetail(null);
        }
      });
    });
    function getContainer() {
      return document.body;
    }

    const tableShowBtnRef = ref<any>(null);

    const isShowDrop = ref(false);

    onUpdated(() => {
      const el = tableShowBtnRef.value;
      if (el) {
        const btns = el.querySelectorAll(".table-btn");
        isShowDrop.value = btns?.length > 2;
      }
    });
    return {
      showSubmitBtn,
      showAgreeBtn,
      showRejectBtn,
      showCancelBtn,
      showVoidBtn,
      ...toRefs(state),
      onLoading,
      existRelation,
      bizId,
      bizName,
      showLostOrderBtn,
      refreshApprovalDetail,
      showEditFlg,
      getContainer,
      tableShowBtnRef,
      isShowDrop,
    };
  },
});
</script>

<style lang="less" scoped>
.btn-list {
  :deep(.table-btn) {
    margin: 0 5px;
    display: inline-block;
    &:nth-child(n + 3) {
      display: none;
    }
  }
}
.trigger-icon {
  cursor: pointer;
  overflow: hidden;
  padding: 0 5px;
  .svg-icon {
    margin-top: 4px;
  }
}

.ant-dropdown-trigger {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
}
.btn-menu {
  :deep(.table-btn) {
    display: block;
    padding: 5px 40px;
    text-align: center;
    &:nth-child(1),
    &:nth-child(2) {
      display: none;
    }
  }
}
</style>
